import { req } from 'react-reqq-lite';
import { toastSuccess } from 'react-geek-toast';

import { removeEmpty } from 'helper';

import { transformCashback, transformCashbackPayload } from './transformers';

export const cashbackList = (biller_id, role, params) => {
  const URL = {
    biller: '/core_merchant/v1/biller_mgmt/biller_cashback/settings',
    organization: `/core_merchant/v1/biller_mgmt/billers/${biller_id}/cashbacks/settings`,
  };
  req.get({
    key: 'CASHBACK_LIST',
    url: URL[role],
    params: removeEmpty(params),
    transform: (res) => (res?.data || []).map(transformCashback),
    onSuccess: (res) => {
      const meta = res?.response?.meta;
      req.set('CASHBACK_PAGER', {
        current_page: meta?.current_page,
        total_pages: meta?.last_page,
        total: meta?.total,
      });
    },
  });
};

export const selectedCashback = (biller_id, cashback_id, role) => {
  const URL = {
    biller: `/core_merchant/v1/biller_mgmt/biller_cashback/settings/${cashback_id}`,
    organization: `/core_merchant/v1/biller_mgmt/billers/${biller_id}/cashbacks/settings/${cashback_id}`,
  };
  req.get({
    key: 'SELECTED_CASHBACK',
    url: URL[role],
    transform: ({ data }) => transformCashback(data),
  });
};

export const addCashback = (payload, biller_id, role, onSuccess) => {
  const URL = {
    biller: '/core_merchant/v1/biller_mgmt/biller_cashback/settings',
    organization: `/core_merchant/v1/biller_mgmt/billers/${biller_id}/cashbacks/settings`,
  };
  req.post({
    key: 'ADD_CASHBACK',
    url: URL[role],
    payload: transformCashbackPayload(payload),
    onSuccess: () => {
      toastSuccess('Cashback added!');
      setTimeout(() => {
        cashbackList(biller_id, role);
      }, 500);
      if (typeof onSuccess === 'function') onSuccess();
    },
  });
};

export const updateCashback = (
  payload,
  biller_id,
  cashback_id,
  role,
  onSuccess
) => {
  const URL = {
    biller: `/core_merchant/v1/biller_mgmt/biller_cashback/settings/${cashback_id}`,
    organization: `/core_merchant/v1/biller_mgmt/billers/${biller_id}/cashbacks/settings/${cashback_id}`,
  };
  req.put({
    key: 'UPDATE_CASHBACK',
    url: URL[role],
    payload: transformCashbackPayload(payload),
    onSuccess: () => {
      toastSuccess('Cashback updated!');
      setTimeout(() => {
        cashbackList(biller_id, role);
      }, 500);
      if (typeof onSuccess === 'function') onSuccess();
    },
  });
};

export const deleteCashback = (biller_id, cashback_id, role, onSuccess) => {
  const URL = {
    biller: `/core_merchant/v1/biller_mgmt/biller_cashback/settings/${cashback_id}`,
    organization: `/core_merchant/v1/biller_mgmt/billers/${biller_id}/cashbacks/settings/${cashback_id}`,
  };
  req.remove({
    key: 'DELETE_CASHBACK',
    url: URL[role],
    onSuccess: () => {
      toastSuccess('Cashback deleted!');
      setTimeout(() => {
        cashbackList(biller_id, role);
      }, 500);
      if (typeof onSuccess === 'function') onSuccess();
    },
  });
};
